// Leaflet
// an open-source JavaScript library for mobile-friendly interactive maps
// @link https://leafletjs.com/
// import 'leaflet/dist/leaflet-src.esm'
import L from 'leaflet/dist/leaflet'

export default ( mapId ) => {

  let map = L.map(mapId, {
    center: [50.06189, 14.44264],
    zoom: 16,
    scrollWheelZoom: false, // Vypinam zoomovani/scrollovani pomoci mysi
  });

  // Barevne varianty
  // @link https://leaflet-extras.github.io/leaflet-providers/preview/
  // L.tileLayer('https://maps.omniscale.net/v2/ak-pkk-63946b2a/style.grayscale/{z}/{x}/{y}.png', {
  L.tileLayer('https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png', {
    maxZoom: 22,
    attribution: '&copy; PHG'
  }).addTo(map);

  const pinIcon = L.icon({
    // iconUrl: './img/map-pin.png',
    // iconRetinaUrl: './img/map-pin@2x.png',
    iconUrl: '/static/img/map-pin.png',
    iconRetinaUrl: '/static/img/map-pin@2x.png',
    iconSize: [47, 62],
    iconAnchor: [23, 31],
  });

  L.marker([50.06189, 14.44264], {icon: pinIcon}).addTo(map);
}
